import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Icon from '../Icon';
import './Stepper.scss';

import AddIcon from '../../svg/icons/ic_add_20x20.svg';
import RemoveIcon from '../../svg/icons/ic_remove_20x20.svg';

const removeLeadingZero = (val) => {
  if (!val) {
    return val;
  }
  return val.toString().replace(/^0+/, '');
};

const Stepper = ({
  decrementLabel = 'decrement',
  disabledDecrement,
  disabledIncrement,
  fulfilled,
  groupLabel = 'Stepper Group',
  incrementLabel = 'increment',
  onDecrement,
  onIncrement,
  value,
  ...props
}) => (
  <div className="Stepper" role="group" aria-label={groupLabel} readOnly>
    <Button aria-label={decrementLabel} variant="no-style" disabled={disabledDecrement} onClick={onDecrement}>
      <Icon component={RemoveIcon} name="Remove" />
    </Button>
    <input {...props} pattern="[0-9]*" disabled={fulfilled} type="number" value={removeLeadingZero(value)} aria-label={groupLabel} />
    <Button aria-label={incrementLabel} variant="no-style" disabled={disabledIncrement} onClick={onIncrement}>
      <Icon component={AddIcon} name="Add" />
    </Button>
  </div>
);

Stepper.MinMax = function MinMax(val, min, max) {
  if (typeof min === 'number' && val < min) {
    return min;
  }
  if (typeof max === 'number' && val > max) {
    return max;
  }
  return val;
};

Stepper.displayName = 'Stepper';

Stepper.propTypes = {
  decrementLabel: PropTypes.string,
  disabledDecrement: PropTypes.bool,
  disabledIncrement: PropTypes.bool,
  fulfilled: PropTypes.bool,
  groupLabel: PropTypes.string,
  incrementLabel: PropTypes.string,
  onDecrement: PropTypes.func,
  onIncrement: PropTypes.func,
  value: PropTypes.number,
};

Stepper.defaultProps = {
  decrementLabel: undefined,
  disabledDecrement: false,
  disabledIncrement: false,
  fulfilled: false,
  groupLabel: undefined,
  incrementLabel: undefined,
  onDecrement: () => {},
  onIncrement: () => {},
  value: 0,
};

export default Stepper;
